export const BRAND = '#556830';
export const BRAND_DARK = '#203622';
export const BRAND_GOLD = '#F1B51C';
export const SURFACE_HOVER = '#E2E7EA';
